import { IAnnotation } from '@indices/def';

export const annotation:IAnnotation = {
  circle: {
    pricePoints: [
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 11,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 1,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 19,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 10,
          day: 25,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 25,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 21,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 13,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 20,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 5,
          day: 20,
        },
      },
    ],
    IndicePoints: [
      {
        color: 'red',
        date: {
          year: 2013,
          month: 4,
          day: 11,
        },
      },
      {
        color: 'red',
        date: {
          year: 2013,
          month: 12,
          day: 1,
        },
      },
      {
        color: 'red',
        date: {
          year: 2017,
          month: 12,
          day: 19,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 10,
          day: 25,
        },
      },
      {
        color: 'green',
        date: {
          year: 2011,
          month: 11,
          day: 25,
        },
      },
      {
        color: 'green',
        date: {
          year: 2015,
          month: 1,
          day: 21,
        },
      },
      {
        color: 'green',
        date: {
          year: 2018,
          month: 12,
          day: 13,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 3,
          day: 20,
        },
      },
      {
        color: 'green',
        date: {
          year: 2020,
          month: 5,
          day: 20,
        },
      },
    ],
  },
};
